import { CommonModule } from '@angular/common'
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { Router, RouterModule } from '@angular/router'
import { AnimationOptions } from 'ngx-lottie'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { AccountService } from 'src/app/service/account/account.service'
import { AuthUserService } from 'src/app/service/auth/auth-user.service'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { DialogAreYouSure } from 'src/app/shared/ddc/ddc-navbar/ddc-navbar.component'
import { DdcButtonSTwoComponent } from '../../shared/ddc/ddc-button-s-two/ddc-button-s-two.component'
@Component({
  selector: 'ddc-setting-account',
  templateUrl: './ddc-setting-account.component.html',
  styleUrl: './ddc-setting-account.component.scss',
  imports: [AngularMaterialsModules, CommonModule, RouterModule, DdcButtonSTwoComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DdcSettingAccountComponent {
  // This is the option that uses the package's AnimationOption interface
  options: AnimationOptions = {
    path: '/assets/lottie/green-tick-6.json',
    loop: false, // Set loop to false for a single playthrough
    autoplay: true,
  }

  _error: string
  _resetDataCompleted = false
  _resetNetworkCompleted = false

  // _languages: SelectOption[] = []

  constructor(
    private logger: DdcLoggerService,
    private account_srv: AccountService,
    public dialog: MatDialog,
    public auth_user: AuthUserService,
    private router: Router,
  ) {}

  ngOnInit(): void {}

  removeAlerts(): void {
    this._error = ''
    this._resetDataCompleted = false
    this._resetNetworkCompleted = false
  }

  resetDataDialog(): void {
    this.removeAlerts()
    let dialogRef = this.dialog.open(DialogAreYouSure, {
      data: {
        type: 'reset_data',
        question: 'Are you sure you want to reset ALL of your data?',
      },
    })

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'reset_data') {
        this._resetDataCompleted = true
      }
    })
  }

  resetNetworkDialog(): void {
    this.removeAlerts()
    let dialogRef = this.dialog.open(DialogAreYouSure, {
      data: {
        type: 'reset_network',
        question: 'Are you sure you want to reset ALL of your network connections?',
      },
    })

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'reset_network') {
        this._resetNetworkCompleted = true
      }
    })
  }

  deleteAccountDialog(): void {
    this.removeAlerts()
    let dialogRef = this.dialog.open(DialogAreYouSure, {
      data: {
        type: 'delete_account',
        question: 'Are you sure you want to delete your Daydic account including all of your data?',
      },
    })

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'delete_account') {
        //sign out and go to login page
        // this.auth_user.sign_out()
        this.router.navigate(['/login'])

        this._resetNetworkCompleted = true
      }
    })
  }
}
